export const BASE_ACTION_TYPES = {
    CLEAR_STORE: '@CLEAR_STORE',
    REFRESH_STORE: '@REFRESH_STORE'
};
const constants = {
    BASE_ACTION_TYPES
};

export default constants;
